/**
 * Studio → Skills (parent layout) — outlets the index + detail routes
 * underneath `/studio/skills`.
 *
 * Pre-refactor this file mounted `<SkillEditor scope="tenant" />` directly,
 * which made `/studio/skills/:id` impossible because the child detail
 * route had nowhere to render.
 *
 * Closes #153 (Studio: replace Skills + Prompts sheet editors with full
 * detail pages). The list lives in `skills.index.tsx`; the detail page
 * in `skills.$skillId.tsx`. The Sheet create flow on the list remains
 * for quick authoring — the detail page is the full edit surface
 * (Identity / Instructions / Variables / Tools / Versions / Used by).
 */
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/skills')({
  component: StudioSkillsLayout,
});

function StudioSkillsLayout() {
  return <Outlet />;
}
